
export const GRAY_RELEASE_KEYS = {
    // AIGC
    aigc: 'ai.write.white.list',
    aigcSelection: 'ai.write.selection',
    aigcHeadingContinue: 'ai.write.headingContinue',
    aigcShengChengTuPian: 'ai.write.actionMenu.shengChengTuPian',
    aigcSuoXie: 'ai.write.actionMenu.suoXie',
    aigcKuoXie: 'ai.write.actionMenu.kuoXie',
    aigcXuXie: 'ai.write.actionMenu.xuXie',
    // 推荐标题
    aiRecommendTitle: 'ai.recommendTitle',
    // 提及文档的摘要卡片
    mentionDocSummaryCard: 'mentionDocSummaryCard',
    // test: 'wiki.test.hym',
    // 新媒介sp1小流量
    // layoutgroupView: 'ku.doc.layoutgroup.view',
    // 空文档生成大纲，触发推荐文档
    aiRecommendDoc: 'ai.recommendDoc',
    // 金丝雀版本小流量
    wikiJSQVersion: 'jsq.version.dropdownMenu',
    // 卡片视图
    cardViewSP3: 'ku.cardView.sp3',
    cardViewMarkKeyPoint: 'ku.cardView.sp3.markKeyPoint',
    wikiJSQBetaVersion: 'jsq.version.beta',
    wikiJSQCanary01Version: 'jsq.version.canary01',
    kuBlindBoxPrize: 'ku-blind-box-prize',
    rightCommentFollow: 'ku.doc.rightCommentFollow',
    dragMenuAigc: 'drag.menu.aigc',
    horizontalDrag: 'ku.doc.horizontalDrag',
    showTableSelectionMenu: 'ku.doc.showTableSelectionMenu',
    coinPraise: 'ku.doc.coinPraise',
    // 视图切换弱化小流量
    moveCardEntry: 'ku.editor.moveCardEntry',
    // 文档关联会议信息
    relatedMeetings: 'ku.doc.relatedMeetings',
    exportMarkdown: 'ku.doc.exportMarkdown',
    autoSavedComment: 'ku.editor.autoSavedComment',
    robotManifestation: 'ku.doc.robotManifestation',
    // 加载动态脚本
    loadDynamicScript: 'ku.doc.loadDynamicScript',


    // 权限展示细节调整：知识本不继承权限时，知识库管理员相关人数展示
    kuUnAuthRepoCount: 'ku.repo.auth.repoCount',
    // 页面权限申请默认选中页面管理员
    kuAuthSmartApply: 'ku.auth.smartApply',
    // 页面管理员申请
    pageAdminapply: 'pageAdmin.apply',
    // 定位文档双滚动条日志
    kuDocScrollLog: 'ku.doc.scroll.log',
    // 文档目录卡
    docCatalogCard: 'ku.doc.docCatalogCard',
    // hiddenRepo: 'ku.sdk.repo.hidden',
    // 流程图、思维导图进入编辑路径优化
    flowChartInGray: 'ku.editChart.optimize',
    // 新版卡片标题大纲
    navCardHead: 'ku.doc.navCardHead',
    // 默认关注权限变更
    openDocSubscribePermission: 'ku.open.doc.subscribe.permission',
    // 子文档列表卡-编辑态
    subDocList: 'ku.doc.sub.doc.list',
    // 组织维度授权引导
    addGroupPower: 'ku.home.addGroupPower',
    limitedTimeRedemption: 'ku.home.limitedTimeRedemption',

    // 关于我的汇总信息
    aboutMe: 'ku.doc.aboutMe',
    // 数据表合并表创建入口
    datasheetMergeTable: 'vika.mergeTable.create',
    // 新建知识本逻辑优化
    knowledgeBookOptimizeGray: 'ku.knowledgeBook.optimize',
    // 重新分页参数新增
    newReslideParams: 'ku.editor.newReslide',

    repoBatchOperate: 'ku.repo.batchOperate',
    // 批量移动
    repoBatchMove: 'ku.repo.batchMove',

    // 页面视图设置
    pageViewSettingGray: 'ku.doc.pageViewSetting',

    // 随心搭
    flexBuilder: 'ku.doc.flexBuilder',
    // 随心搭代码 Diff 修改
    flexBuilderCodeDiff: 'ku.doc.flexBuilderCodeDiff',
    // 随心搭-能正常使用，但隐藏自定义生成的入口
    flexBuilderLite: 'ku.doc.flexBuilderLite',
    // 知识库随心搭"+"官方文档 prompt
    flexBuilderPlusDoc: 'ku.doc.flexBuilderPlusDoc',
    // 随心搭-组件编译错误重试功能入口
    flexBuilderRetryComponentBuildError: 'ku.doc.flexBuilderRetryComponentBuildError',
    // 随心搭调试工具
    flexBuilderDevTool: 'ku.doc.flexBuilderDevTool',
    // 随心搭局部编辑
    flexBuilderSelective: 'ku.doc.flexBuilderSelective',
    // 后端随心搭
    backendFlexBuilder: 'ku.doc.backendFlexBuilder',
    // 随心搭加号能力 - 后端随心搭模块
    flexBuilderPlusForBackendFlexBuilder: 'ku.doc.flexBuilderPlusForBackendFlexBuilder',
};

